export default __webpack_public_path__ + "static/media/Vikki-Garner.7dfd8aa2.jpeg";